import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../services/api";
import toast from "react-hot-toast";

const Signup = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({
        institution_name: "",
        username: "",
        email: "",
        phone: "",
        password: "",
        confirm_password: "",
    });

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.password !== form.confirm_password) {
            toast.error("Passwords do not match");
            return;
        }

        try {
            setLoading(true);

            await authAPI.signup({
                institution_name: form.institution_name,
                username: form.username,
                email: form.email,
                phone: form.phone,
                password: form.password,
            });

            toast.success("School Registered Successfully");

            navigate("/login");
        } catch (err) {
            console.error(err);

            toast.error(
                err?.response?.data?.message ||
                "Signup Failed"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-card">

                <div className="auth-logo">
                    <div className="logo-icon">🏫</div>

                    <h2>SchoolERP</h2>

                    <p>Create School Account</p>
                </div>

                <form onSubmit={handleSubmit}>

                    <div className="mb-3">
                        <label className="form-label">
                            School Name
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            name="institution_name"
                            placeholder="Enter School Name"
                            value={form.institution_name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">
                            Username
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            name="username"
                            placeholder="Enter Username"
                            value={form.username}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">
                            Email
                        </label>

                        <input
                            type="email"
                            className="form-control"
                            name="email"
                            placeholder="Enter Email"
                            value={form.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">
                            Phone
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            name="phone"
                            placeholder="Enter Phone Number"
                            value={form.phone}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">
                            Password
                        </label>

                        <input
                            type="password"
                            className="form-control"
                            name="password"
                            placeholder="Enter Password"
                            value={form.password}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="mb-4">
                        <label className="form-label">
                            Confirm Password
                        </label>

                        <input
                            type="password"
                            className="form-control"
                            name="confirm_password"
                            placeholder="Confirm Password"
                            value={form.confirm_password}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-success w-100"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Creating...
                            </>
                        ) : (
                            "Create School Account"
                        )}
                    </button>

                </form>

                <div className="text-center mt-4">

                    Already have an account?

                    <button
                        className="btn btn-link"
                        onClick={() => navigate("/login")}
                    >
                        Sign In
                    </button>

                </div>

            </div>
        </div>
    );
};

export default Signup;